import {contactSchema} from './contact.schema';
import {locationSchema} from './location.schema';

export const beneficiarySchema = `
            id
            firstName
            lastName
            contact{
                ${contactSchema}
            }
            location {
                ${locationSchema}
            }
            bankDetails{
                name
                sortCode
                accountNumber
            }
    `;
